import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
   Card, CardBody, Row, Col
} from 'reactstrap';
import { TextField } from '../../../shared/TextField';
import { UserSearchAutocomplete } from '../../../shared/UserSearchAutocomplete';
import { ListUsersWithCertificate } from './ListUsersWithCertificate';
import { PRODUCT_GROUPS } from '../../../../config/constants';
import {
  calculateTotalPriceOnCustomOrderWithoutVat, getCustomOrderProduct
} from '../../../../helpers/general';
import { ErrorMessage } from 'formik';
import { Messages } from '../../../layout/Messages/Messages';

function CertificateFields(props) {
  const [ userWithCertificate, setUserWithCertificate ] = useState( [] );
  const [ userWithOutCertificate, setUserWithOutCertificate ] = useState( props.users );

  useEffect( () => {
    // When list of users is changed(organization is changed)
    setUserWithOutCertificate( props.users );
    setUserWithCertificate( [] );
    props.formikProps.setFieldValue( 'usersWithCertificate', [] );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ props.users ] );

  const getCurrencyOfProduct = () => {
    let productGroup;
    props.productGroups.forEach( item => {
      if (item.name === PRODUCT_GROUPS.CERTIFICATE.name) {
        productGroup = item;
      }
    } );

    return getCustomOrderProduct(productGroup).currency;
  }

  const calculateTotalPrice = () => {
    if (isNaN( props.formikProps.values.certificatesNumber ) || isNaN( props.formikProps.values.certificatesValue )) {
      return `0 ${getCurrencyOfProduct()}`;
    }

    return `${calculateTotalPriceOnCustomOrderWithoutVat( props.formikProps.values.certificatesNumber, props.formikProps.values.certificatesValue )} ${getCurrencyOfProduct()}`
  }

  const getIndexOfUser = (data, user) => {
    let i = -1;
    data.forEach( (item, index) => {
      if (item.id === user.id) {
        i = index;
      }
    } );

    return i;
  }

  const assignCertificateToUser = (user) => {
    let cloneOfUserWithCertificate = [ ...userWithCertificate ];
    let cloneUserWithoutCertificate = [ ...userWithOutCertificate ];
    cloneOfUserWithCertificate.push( user );
    cloneUserWithoutCertificate.splice( getIndexOfUser( cloneUserWithoutCertificate, user ), 1 );

    setUserWithCertificate( cloneOfUserWithCertificate );
    setUserWithOutCertificate( cloneUserWithoutCertificate );
    props.formikProps.setFieldValue( 'usersWithCertificate', cloneOfUserWithCertificate );
  }

  const removeCertificateFromUser = (user) => {
    let cloneOfUserWithCertificate = [ ...userWithCertificate ];
    let cloneOfUserWithOutCertificate = [ ...userWithOutCertificate ];

    cloneOfUserWithCertificate.splice( getIndexOfUser( cloneOfUserWithCertificate, user ), 1 );
    cloneOfUserWithOutCertificate.push( user );

    setUserWithOutCertificate( cloneOfUserWithOutCertificate );
    setUserWithCertificate( cloneOfUserWithCertificate );
    props.formikProps.setFieldValue( 'usersWithCertificate', cloneOfUserWithCertificate );
  }

  return (
    <Card id="certificates-content">
      <CardBody>
        {props.organization ? <>
          <Row className="align-items-center mb-3">
            <Col xs={12} sm={3}>
              <FormattedMessage
                id="components.pages.orderManagement.selectProductGroup.certificates.number"/>
            </Col>
            <Col xs={12} sm={9}>
              <TextField
                name="create_order.number"
                value={props.formikProps.values.certificatesNumber}
                classNameFormGroup="m-0"
                onChange={(e) =>
                  props.formikProps.setFieldValue( "certificatesNumber", e.target.value )
                }
                errorClass={props.getErrorClass( props.formikProps, 'certificatesNumber' )}
              />
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="certificatesNumber"
                  component="div"
                  data-testid="errors-certificatesNumber"
                  className="field-error"
                />
              </Messages>
            </Col>
          </Row>
          <Row className="align-items-center mb-3">
            <Col xs={12} sm={3}>
              <FormattedMessage
                id="components.pages.orderManagement.selectProductGroup.simple_signatures.price"/>
            </Col>
            <Col xs={12} sm={9}>
              <TextField
                name="create_order.value"
                value={props.formikProps.values.certificatesValue}
                classNameFormGroup="m-0"
                onChange={(e) =>
                  props.formikProps.setFieldValue( "certificatesValue", e.target.value )
                }
                errorClass={props.getErrorClass( props.formikProps, 'certificatesValue' )}
              />
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="certificatesValue"
                  component="div"
                  data-testid="errors-certificatesValue"
                  className="field-error"
                />
              </Messages>
            </Col>
          </Row>
          <Row className="align-items-center mb-3">
            <Col xs={12} sm={3}>
              <FormattedMessage
                id="components.pages.orderManagement.createOrderForm.select_user_for_certificate"/>
            </Col>
            <Col xs={12} sm={9}>
              <UserSearchAutocomplete
                data={userWithOutCertificate}
                errorClass={props.getErrorClass( props.formikProps, 'usersWithCertificate' )}
                onSelect={assignCertificateToUser}/>
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="usersWithCertificate"
                  component="div"
                  data-testid="errors-usersWithCertificate"
                  className="field-error"
                />
              </Messages>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center mb-3">
            <Col xs={12} sm={9}>
              <ListUsersWithCertificate
                users={userWithCertificate}
                removeCertificateFromUser={removeCertificateFromUser}
              />
            </Col>
          </Row>
        </> : <div className="select-organization-error">
          <FormattedMessage
            id="components.pages.orderManagement.createOrderForm.select_organization"/>
        </div>}
        {props.organization && <Row className="create-order-total-val">
          <FormattedMessage
            id="components.pages.orderManagement.selectProductGroup.simple_signatures.sub_total"/> {calculateTotalPrice()}
        </Row>}
      </CardBody>
    </Card>
  );
};


export { CertificateFields };
